/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Components/Global                                                                    **/
/**************************************************************************************************/
import * as CompanyLogo from '@/Components/Global/CompanyLogo/template.vue'

/**************************************************************************************************/
/** @import Helpers/Utils                                                                        **/
/**************************************************************************************************/
import { PrintHelper } from '@/Helpers/Utils/PrintHelper'

/**************************************************************************************************/
/** @import Mixins                                                                               **/
/**************************************************************************************************/
import MixinComponent  from '@/Mixins/MixinComponent'
import MixinResponsive from '@/Mixins/MixinResponsive'

/**************************************************************************************************/
/** @internal Const @name AttributesList                                                         **/
/**************************************************************************************************/
const AttributesList = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'AttributesList', mixins: [MixinComponent, MixinResponsive],

	components:
	{
		CompanyLogo: CompanyLogo.default
	},

	props:
	{
		show: Boolean
	},

	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			states:
			{
				data: undefined as any,
				type: 'actives',
				options: [] as Array<any>
			}
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		IsActives() : boolean
		{
			return this.states.type === 'actives'
		},

		OnALCloseClick() : void
		{
			PrintHelper.warning('[AttributesList]:onALCloseClick() event triggered')
			this.$emit('onALCloseClick')
		}
	}
})

/**************************************************************************************************/
/** @export Component @name AttributesList                                                       **/
/**************************************************************************************************/
export default AttributesList

/**************************************************************************************************/
/** @export Type @name AttributesListRef                                                         **/
/**************************************************************************************************/
export type AttributesListRef = InstanceType<typeof AttributesList>